const texts = {
    errors:{
        user_not_found:"Користувача не знайдено",
        user_already_exists:"Користувач вже існує",
        client_already_exists: "Клієнт з таким іменем вже існує",
        wrong_password:"Невірний пароль",
        invalid_token:"Невірний токен",
        invalid_data:"Невірні дані",
        wrong_file_format:"Невірний формат файлу",
        access_denied:"У вас немає доступу до цієї функції",
        not_found:"Запис не знайдено",
        file_not_uploaded: "Файл не завантажено!",
        file_not_found:"Файл не знайдено!",
        order_delete_failed:"Не вдалося видалити замовлення!",
    },
    messages:{
        user_updated:"Користувача успішно оновлено",
        user_created:"Користувача успішно створено",
        user_deleted:"Користувача успішно видалено",
        client_updated:"Клієнта успішно оновлено",
        client_has_orders:"Клієнт має замовлення, видалення не можливе!",
        order_created:"Замовлення успішно створено",
        order_updated:"Замовлення успішно оновлено",
        file_deleted:"Файл {name} успішно видалено",
    },
    asks:{
        delete_user:"Ви впевнені, що хочете видалити користувача?",
        delete_file:"Ви впевнені, що хочете видалити цей файл?",
    },
    operations: {
        create: 'Створення',
        update: 'Оновлення',
        delete: 'Видалення',
        get: 'Отримання',
        getByType: 'Отримання за типом',
        getByDate: 'Отримання за датою',
        login: 'Авторизація (вхід)',
        logout: 'Вихід',
        upload: 'Завантаження файлу',
        get_order: 'Отримання даних замовлення',
        edit_order: 'Редагування даних замовлення',
        error: 'Помилка в системі',
    },
    logs: {
        orderSetCutting: "Замовленню {title} встановлено статус 'Порізка'",
        orderSetCuttingDone: "Порізку для замовлення {title} завершено",
        checkboxSet: "Встановлено відмітку '{label}'",
        checkboxUnset: "Знято відмітку '{label}'",
        noPatternsTypeChanged: "Статус відсутності лекал: '{value}'",
        noPatternsTypeCleared: "Очищено статус відсутності лекал",
        assemblyProgramChanged: "Програма збірки лекала: '{value}'",
        assemblyProgramCleared: "Очищено програму збірки лекала"
    },
    titles:{
        error: 'Помилка',
        success: 'Успішно',
        alert: 'Увага',
    },
    buttons:{
        create:"Створити",
        update:"Оновити",
        delete:"Видалити",
        confirm:"Підтвердити",
        cancel:"Скасувати",
        get:"Отримати",
        upload:"Завантажити",
        get_order:"Отримати замовлення",
        edit_order:"Редагувати замовлення",

    },
    logwords: {
        hasProblematicPattern: "Проблемна викрійка",
        hasProblematicPackaging: "Проблема упаковки",
        wasCut: "Лекало порізане",
        hasNoPatterns: "Немає лекал",
        patternRequestSent: "Відправлено запит на отримання лекал",
        noPatternsNoneInAny: "Немає лекал в жодній з баз",
        noPatternsNoneInOurs: "Немає лекал в наших базах",
        noPatternsPartial: "Є лекала частково"
    }

}

module.exports = texts;